import { Component, inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

@Component({
  selector: 'custom-snackbar',
  template: `
    <div class="snack-bar-container">
      <div>
        {{ data }}
      </div>
      <div>
        <mat-icon class="close-icon" (click)="close()">close</mat-icon>
      </div>
    </div>
  `,
  styles: [
    `
      .snack-bar-container {
        display: flex;
        justify-content: space-between;
        height: 2rem;
      }
      .close-icon {
        cursor: pointer;
        font-size: 2rem;
      }
      ::ng-deep .snack-bar-default {
        margin: 0 0 3rem 22.5rem !important;
      }
    `,
  ],
  standalone: false,
})
export class SnackbarComponent {
  private readonly _snackBarRef =
    inject<MatSnackBarRef<SnackbarComponent>>(MatSnackBarRef);
  public readonly data = inject<string>(MAT_SNACK_BAR_DATA);

  close() {
    this._snackBarRef.dismiss();
  }
}
// TODO: convert this to standalone component
